import React, { Fragment } from 'react';
import { useSubRoutes, SUBROUTES_MAP, ROUTES } from 'Navigation';

export const ConfigurationMain: React.FC = () => {
  const mapSubRoutes = useSubRoutes();
  return (
    <Fragment>{mapSubRoutes(SUBROUTES_MAP[ROUTES.CONFIGURATION])}</Fragment>
  );
};
